import React, { useContext, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import apiFetch from "../../utils/apiUtils";
import { ErrorContext, MilestoneTypes } from "../../utils/constants";
import Colors from '../../utils/colors';
import Button from "@material-ui/core/Button";
import Typography from '@material-ui/core/Typography';
import '@fontsource/inter';
import ExpansionCard from '../ExpansionCard';
import StakeholderMilestoneCard from './StakeholderMilestoneCard';

export const stakeholderMilestoneContent = [
    {
        id: -1,
        milestoneType: 1,
        title: 'SOX Review',
        description: [
            'Does your initiative impact financial data, the lifespan of assets, existing controls, ',
            'or IT systems which are relied on for financial data?'
        ].join(''),
        helpText: '',
        sent_for_review_user: null,
        reviewer_name: null,
        status_id: null
    },
    {
        id: -1,
        milestoneType: 2,
        title: 'IT Review',
        description: 'Does your initiative involve new software or a change in IT infrastructure?',
        helpText: '',
        sent_for_review_user: null,
        reviewer_name: null,
        status_id: null
    },
    {
        id: -1,
        milestoneType: 3,
        title: 'HR Review',
        description: [
            'Does your initiative involve a change in staffing, a change in job description, or possibly impact ',
            'a collective bargaining agreement?'
        ].join(''),
        helpText: '',
        sent_for_review_user: null,
        reviewer_name: null,
        status_id: null
    },
    {
        id: -1,
        milestoneType: 4,
        title: 'FSSG Review',
        description: 'Does your initiative involve a change to SAP systems or data structures?',
        helpText: '',
        sent_for_review_user: null,
        reviewer_name: null,
        status_id: null
    },
    {
        id: -1,
        milestoneType: 7,
        title: 'Operation Services Review',
        description: 'Does your initiative require any TSMS policy changes (MOC, Work Mgmt/Maint. Strategies, Risk Mgmt, Op. logbooks/handover, Eng. Standards)?',
        helpText: '',
        sent_for_review_user: null,
        reviewer_name: null,
        status_id: null
    },
    {
        id: -1,
        milestoneType: 8,
        title: 'Shared Services Finance Review',
        description: 'Does your initiative affect TransAlta\'s budget or spending patterns?',
        helpText: '',
        sent_for_review_user: null,
        reviewer_name: null,
        status_id: null
    },
    {
        id: -1,
        milestoneType: 9,
        title: 'Organizational Change Management Review',
        description: 'Does your initiative impact employees through a change or implementation of a tool/process?',
        helpText: '',
        sent_for_review_user: null,
        reviewer_name: null,
        status_id: null
    },
    {
        id: -1,
        milestoneType: 10,
        title: 'Scientific Research and Experimental Development (SR&ED) Review',
        description: ['Does your initiative involve resolving scientific or technological uncertainty and/or development of ',
            'knowledge not already in the public domain?'
        ].join(''),
        helpText: '',
        sent_for_review_user: null,
        reviewer_name: null,
        status_id: null
    },
    {
        id: -1,
        milestoneType: 11,
        title: 'Supply Chain Management',
        description: 'Does this initiative involve any of the following: expenditure outside of the company with an existing or new supplier, supplier management, or an RFP?',
        helpText: '',
        sent_for_review_user: null,
        reviewer_name: null,
        status_id: null
    }
];


const useStyles = makeStyles(() => ({
    mandatoryMilestoneContainer: {
        display: 'flex',
        flexDirection: 'row',
        width: '100%'
    },
    mandatoryMilestoneDescription: {
        paddingRight: '2rem',
        width: '66%',
        paddingTop: '2rem'
    },
    milestoneHelp: {
        marginTop: '2rem',
        padding: '2%',
        width: '34%',
        background: 'rgba(110, 247, 138, 0.1)',
    },
    styledSwitch: {
        fontFamily: 'Inter',
        fontStyle: 'normal',
        fontWeight: 500,
        fontSize: '16px',
        lineHeight: '22px',
        textAlign: 'center',
        marginTop: '3rem',
        marginBottom: '3rem'
    },
    checkedCircle: {
        marginRight: '1rem',
        color: Colors.tertiary
    },
    highlightOff: {
        marginRight: '1rem',
        color: '#db6a34'
    },
    sendForReviewerContainer: {
        margin: '1rem',
        textAlign: 'center'
    },
    sendForReviewButton: {
        backgroundColor: Colors.darkBlue,
        "&:hover": {
            backgroundColor: Colors.brightBlue,
            color: Colors.indigoBlue
          },
        width: '30%',
    },
    sendForReviewHiddenButton: {
        backgroundColor: Colors.darkBlue,
        "&:hover": {
            backgroundColor: Colors.brightBlue,
            color: Colors.indigoBlue
          },
        width: '30%',
        visibility: 'hidden'
    },

}));

let selectedMilestones = [];

export default function StakeholderMilestones({ milestones, initiative, onSuccess, initiativeTeam, milestoneReviewers }) {
    const { triggerError } = useContext(ErrorContext);
    const { id: initiativeId } = initiative;

    const [sendForReviewButtonEnabled, setSendForReviewButtonEnabled] = useState(!!selectedMilestones.length);

    const stakeholderMilestonesTypes = MilestoneTypes.map(function (item) { return (item.label === "Stakeholder Review" ? item.value : null) }).filter(n => n !== null)
    const stakeholderMilestones = milestones.filter(item => stakeholderMilestonesTypes.indexOf(item.type) !== -1);

    const classes = useStyles();

    const hasMilestoneOfType = (milestoneType) => !!milestones.filter(({ type }) => milestoneType === type).length;
    const getMilestoneOfType = (milestoneType) => milestones.find(({ type }) => milestoneType === type);

    const handleOnSelect = (data) => {
        selectedMilestones = selectedMilestones.filter(({ milestoneType }) => milestoneType !== data[0].milestoneType);
        const stakeholderMilestoneId = milestones.find(({ type }) => data[0].milestoneType === type) !== undefined ? milestones.find(({ type }) => data[0].milestoneType === type).id : null
        if (data[0].value !== "") {
            selectedMilestones.push({
                id: stakeholderMilestoneId,
                name: stakeholderMilestoneContent[data[0].index].title,
                description: stakeholderMilestoneContent[data[0].index].description,
                milestoneType: data[0].milestoneType,
                index: data[0].index,
                action: data[0].action,
                value: data[0].value,
                status: data[0].value === "yes" ? 1 : (data[0].value === "no" ? 3 : 5)
            });
        }
        if (stakeholderMilestones.length === 0) {
            setSendForReviewButtonEnabled(selectedMilestones.length === stakeholderMilestonesTypes.length)
        }
        else {
            setSendForReviewButtonEnabled(!!selectedMilestones.length)
        }
    };

    const handleSendForReviewButton = () => {
        const newStakeholderMilestones = selectedMilestones.filter(({ id }) => id === null);
        const currentStakeholderMilestones = selectedMilestones.filter(({ id }) => id !== null);
        if(newStakeholderMilestones.length !== 0)
        {
            createNewStakeholderMilestoneRecords(newStakeholderMilestones);
        }
        if(currentStakeholderMilestones.length !== 0)
        {
            updateStakeholderMilestoneRecords(currentStakeholderMilestones);
        }
        selectedMilestones = [];
        setSendForReviewButtonEnabled(false);
    }

    const createNewStakeholderMilestoneRecords = (stakeholderMilestones) => {
        apiFetch(
            `/initiatives/${initiativeId}/createstakeholdermilestones`,
            'POST',
            JSON.stringify(stakeholderMilestones),
            onSuccess
            ,
            () => triggerError({
                title: 'Communication Error',
                description: 'We were unable to create new stakeholder milestones. Please try again.',
                //onRetry: requestReviewStakeholderMilestone,
            })
        )
    }

    const updateStakeholderMilestoneRecords = (stakeholderMilestones) => {
        apiFetch(
            `/initiatives/${initiativeId}/updatestakeholdermilestones`,
            'POST',
            JSON.stringify(stakeholderMilestones),
            onSuccess
            ,
            () => triggerError({
                title: 'Communication Error',
                description: 'We were unable to update stakeholder milestones. Please try again.',
                //onRetry: requestReviewStakeholderMilestone,
            })
        )
    }

    return (
        <div style={{ margin: '1rem 0' }}>

            <Typography variant='h5' component='h2' style={{ margin: '1rem', marginLeft: '0' }}  >
                Stakeholder Milestones
            </Typography>
            {stakeholderMilestoneContent.map((milestone, index) => (
                <ExpansionCard
                    header={milestone.title}
                    milestone={milestone}
                    isStakeholder={true}
                    key={index}
                    detailsCard={hasMilestoneOfType(milestone.milestoneType) ?
                        <StakeholderMilestoneCard
                            key={index}
                            index={index}
                            initiativeTeam={initiativeTeam}
                            milestoneReviewers={milestoneReviewers}
                            milestone={getMilestoneOfType(milestone.milestoneType)}
                            onSuccess={onSuccess}
                            hasOtherStakeholderMilestones={null}
                            onSelect={handleOnSelect}
                        /> : <StakeholderMilestoneCard
                            key={index}
                            index={index}
                            initiativeTeam={initiativeTeam}
                            milestoneReviewers={milestoneReviewers}
                            milestone={milestone}
                            onSuccess={onSuccess}
                            hasOtherStakeholderMilestones={stakeholderMilestoneContent.filter(element => milestones.find(({ type }) => element.milestoneType === type)).length > 0}
                            onSelect={handleOnSelect}
                        />
                    }
                />
            ))}
            <div className={classes.sendForReviewerContainer}>
                <Button variant="contained" color="primary"
                    className={!sendForReviewButtonEnabled ? classes.sendForReviewHiddenButton : classes.sendForReviewButton}
                    onClick={handleSendForReviewButton}
                >SEND FOR REVIEW</Button>
            </div>
        </div>
    );
}
